import { __decorate } from "tslib";
import "element-internals-polyfill";
import { css, html, LitElement } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
let CheckboxEditorInlineElement = class CheckboxEditorInlineElement extends LitElement {
    get liveValue() {
        return this._liveValue;
    }
    constructor() {
        super();
        this.disabled = false;
        this.editorSize = "normal";
    }
    willUpdate(changedProperties) {
        if (changedProperties.has("value")) {
            this.oldValue = this.value;
            this._liveValue = this.value;
            if (this.tristate === undefined && this.value === undefined) {
                this.tristate = "always";
            }
        }
    }
    disable(isDisable = true) {
        this.disabled = isDisable;
    }
    async reportValidity() {
        return true;
    }
    setCustomValidity(error) {
        //do nothing
    }
    firstUpdated() { }
    cancel() {
        this._liveValue = this.value;
        this.requestUpdate();
    }
    onMouseUp() {
        if (this.disabled || this.readonly)
            return;
        switch (this._liveValue) {
            case undefined:
                if (this.tristate === "auto")
                    this._liveValue = false;
                else
                    this._liveValue = true;
                break;
            case true:
                this._liveValue = false;
                break;
            case false:
                if (this.tristate === "always")
                    this._liveValue = undefined;
                else
                    this._liveValue = true;
                break;
        }
        this.dispatchEvent(new CustomEvent("valueChanged", {
            bubbles: true,
            composed: true,
            detail: { editor: this, value: this._liveValue, oldValue: this.value },
        }));
        this.dispatchEvent(new CustomEvent("editorChanged", { bubbles: true, composed: true, detail: { editor: this } }));
    }
    render() {
        const iconClass = this._liveValue === undefined && (this.tristate === "always" || this.tristate === "auto")
            ? "fa-minus-square"
            : this._liveValue === true
                ? "fa-check-square"
                : "fa-square";
        const iconStyle = this._liveValue || (this.tristate === "always" && this._liveValue === undefined) ? { color: "black" } : { color: "gray" };
        const style = { opacity: this.disabled ? "0.7" : "1" };
        const font = { font: this.editorSize === "small" ? "var(--font-input)" : "var(--font-input-large)" };
        return html `
            <div id="editor" style="${styleMap({ ...style, ...font })}" @mouseup=${this.onMouseUp}>
                <fa-icon style=${styleMap(iconStyle)} class="icon" fa-class="far ${iconClass}"></fa-icon>
            </div>
        `;
    }
};
CheckboxEditorInlineElement.styles = css `
        :host {
            display: block;
            font: var(--font);
            line-height: 1.5em;
        }
        :host([hidden]) {
            display: none;
        }
        .icon {
            color: gray;
        }
        .icon:hover {
            color: black;
        }
        #editor {
            box-sizing: border-box;
        }
    `;
__decorate([
    property({ type: Boolean })
], CheckboxEditorInlineElement.prototype, "value", void 0);
__decorate([
    state()
], CheckboxEditorInlineElement.prototype, "_liveValue", void 0);
__decorate([
    property()
], CheckboxEditorInlineElement.prototype, "tristate", void 0);
__decorate([
    property({ type: Boolean })
], CheckboxEditorInlineElement.prototype, "readonly", void 0);
__decorate([
    property({ type: Boolean })
], CheckboxEditorInlineElement.prototype, "disabled", void 0);
__decorate([
    property()
], CheckboxEditorInlineElement.prototype, "name", void 0);
__decorate([
    property({ attribute: "editor-size" })
], CheckboxEditorInlineElement.prototype, "editorSize", void 0);
__decorate([
    query("#editor")
], CheckboxEditorInlineElement.prototype, "_editorElement", void 0);
CheckboxEditorInlineElement = __decorate([
    customElement("se-checkbox-inline-editor")
], CheckboxEditorInlineElement);
export { CheckboxEditorInlineElement };
//# sourceMappingURL=checkbox-editor.element.js.map